import { IonButton, IonIcon } from '@ionic/react';
import { openOutline } from 'ionicons/icons';
import { Browser } from '@capacitor/browser';
import React, { useEffect } from 'react';

import CCPage from '../../../components/CCPage';
import { useStoreActions, useStoreState } from '../../../store';
import './storm-pages.css';

const formatUpdated = (iso: string | null): string => {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    return d.toLocaleString(undefined, {
      year: 'numeric', month: 'long', day: 'numeric',
      hour: 'numeric', minute: '2-digit',
    });
  } catch (e) {
    return iso;
  }
};

const StormPreparePage: React.FC = () => {
  const entry = useStoreState((s) => s.storm.content.prepare);
  const locale = useStoreState((s) => s.translations.language);
  const loadContent = useStoreActions((a) => a.storm.loadContent);

  useEffect(() => {
    loadContent();
  }, [loadContent]);

  const isSpanish = (locale || '').startsWith('es');
  const body = entry ? (isSpanish ? entry.body_es : entry.body_en) : null;
  const updatedAt = entry?.updated_at || null;

  const content = (
    <div className="storm-page-content">
      {updatedAt && (
        <div className="storm-updated-label">
          {isSpanish ? 'Actualizado: ' : 'Last updated: '}{formatUpdated(updatedAt)}
        </div>
      )}

      {!entry && (
        <div className="storm-empty">
          {isSpanish ? 'Cargando contenido...' : 'Loading content...'}
        </div>
      )}

      {body && (
        <>
          {body.intro && (
            <div
              className="storm-page-html"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: body.intro }}
            />
          )}

          {body.checklist && body.checklist.length > 0 && (
            <div className="storm-section">
              <h2 className="storm-section-title">
                {isSpanish ? 'Lista de preparación' : 'Preparation checklist'}
              </h2>
              {body.checklist.map((item, i) => (
                <div className="storm-card" key={i}>
                  <div className="storm-card-title">{item.title}</div>
                  {item.detail && (
                    <div
                      className="storm-page-html"
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{ __html: item.detail }}
                    />
                  )}
                </div>
              ))}
            </div>
          )}

          {body.links && body.links.length > 0 && (
            <div className="storm-section">
              <h2 className="storm-section-title">
                {isSpanish ? 'Enlaces útiles' : 'Useful links'}
              </h2>
              {body.links.map((link, i) => (
                link.url && (
                  <IonButton
                    key={i}
                    className="storm-action-button"
                    expand="block"
                    fill="outline"
                    onClick={() => { Browser.open({ url: link.url }); }}
                  >
                    {link.label || link.url}
                    <IonIcon icon={openOutline} slot="end" />
                  </IonButton>
                )
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );

  return <CCPage title={isSpanish ? 'Prepárese' : 'Prepare'} content={content} />;
};

export default StormPreparePage;
